<template>
    <v-app-bar
      flat
      dense
      light
      color="#fafafa"
      class="up10"
    >
        
      <v-toolbar-title class="text-uppercase font-weight-strong headline">
        <v-app-bar-nav-icon>
          <v-icon color="orange darken-3">{{ this.$route.meta.icon }}</v-icon>
        </v-app-bar-nav-icon>
        <span color="grey darken-2">{{ this.$route.meta.title }}</span></v-toolbar-title>

      <div class="flex-grow-1"></div>

      <!-- breadcrumb -->
      <v-breadcrumbs :items="crumbs" class="up25 hidden-sm-and-down">
        <template v-slot:item="props">
          <v-breadcrumbs-item class="text-uppercase overline">
            {{ props.item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>        

    </v-app-bar>

</template>

<script>
export default {
  name: 'AppTitleBar',
  data() {
    return {
      crumbs: []
    }
  },
  watch: {
    $route() {
      this.crumbs = []
      this.populateCrumbs()
    }
  },
  // == Lifecycle
  created() {
    this.populateCrumbs()
  },
  // == Methods
  methods: {
    populateCrumbs() {
      if (typeof this.$route.meta.breadcrumbs != 'undefined') {
        for (var i = 0; i < this.$route.meta.breadcrumbs.length; i++) {
// {
//     disabled: boolean
//     exact: boolean
//     href: string
//     link: boolean
//     text: string | number
//     to: string | object
// }
          let crumb = {
            text: this.$route.meta.breadcrumbs[i].name,
            // to: this.$route.meta.breadcrumbs[i].to
          }
          this.crumbs.push(crumb)
        }
      }
    }
  }
}
</script>
